let movingAvg = null;

export function getAudioLogLevel(event) {
  if (movingAvg === null || movingAvg <= event.audioLevel) {
    movingAvg = event.audioLevel;
  } else {
    movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
  }

  // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
  let logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
  logLevel = Math.min(Math.max(logLevel, 0), 1);
  return logLevel * 100;
}



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/utils/getAudioLogLevel.js